import dayjs from 'dayjs';

import { IDays } from '@/services/types/core/locations/id';

const TIME_INTERVAL = 15 * 60;
export const MAX_TIME = 86400;

export const mapDateToWeekDay = (date: string) => {
  const weekDayNumber = dayjs(date, 'YYYY-MM-DD').day();
  const weekDays: (keyof IDays)[] = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];
  return weekDays[weekDayNumber];
};

export const mapTimeToIntervals = (rawStartTime: number, rawEndTime: number): number[] => {
  let startTime = rawStartTime;
  let endTime = rawEndTime;
  // Start options at midnight of the current day
  if (!startTime || startTime < 0) startTime = 0;
  // Treat as ending/starting options at midnight of the next day
  if (!endTime || endTime > MAX_TIME) endTime = MAX_TIME;
  if (startTime > MAX_TIME) startTime = MAX_TIME;
  // Impossible, no options returned (start and end time can be the same, we'll allow only this time period in this case)
  if (endTime < 0 || startTime > endTime) return [];

  const period = endTime - startTime;
  const intervals = endTime === MAX_TIME ? period / TIME_INTERVAL : period / TIME_INTERVAL + 1;
  return [...Array(intervals)].map((_, index) => startTime + TIME_INTERVAL * index);
};
